import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { from, of, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

// Functional Interceptor per Angular standalone
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  req = req.clone({ withCredentials: true });

  const token = authService.getAccessToken();
  if (token) {
    req = addTokenToRequest(req, token);
  }
  req = addHeaderApplicationJson(req);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return handle401Error(req, next, authService, router);
      }
      return throwError(() => error);
    }),
  );
};

/**
 * Aggiunge il token di autorizzazione alla richiesta
 */
function addTokenToRequest(
  request: HttpRequest<any>,
  token: string,
): HttpRequest<any> {
  return request.clone({
    setHeaders: {
      'Shib-Iride-IdentitaDigitale': token,
    },
  });
}

function addHeaderApplicationJson(
  request: HttpRequest<any>,
): HttpRequest<any> {
  return request.clone({
    setHeaders: {
      'Accept': 'application/json',
    },
  });
}

/**
 * Gestisce errore 401 (con AuthService, non facciamo refresh manuale)
 */
function handle401Error(
  request: HttpRequest<any>,
  next: any,
  authService: AuthService,
  router: Router,
): Observable<any> {
  // Con AuthService, il token viene gestito automaticamente, quindi su 401 facciamo logout
  authService.logout();
  router.navigate(['/login']);
  return throwError(() => new Error('Authentication failed'));
}
